import Vue from 'vue';

let month = Vue.filter('month', function (value) {
    const months = [
        "Styczeń",
        "Luty",
        "Marzec",
        "Kwiecień",
        "Maj",
        "Czerwiec",
        "Lipiec",
        "Sierpień",
        "Wrzesień",
        "Październik",
        "Listopad",
        "Grudzień"
    ];

    return months[value - 1] || "";
});

let months = Vue.filter('months', function (value) {
    return value.length === 12 ? 'Każdy miesiąc' : value.map(month).join(", ");
});

export default { month, months };